export default __webpack_public_path__ + "static/media/SWT1940.34I-41204_-24574_0.ed3fcb20.jpg";